/**
 * The new sequence after a drag, or `null` when the drag changed nothing.
 *
 * Separated from the drag-and-drop library because this is the part with
 * decisions in it. Three of them end in `null` rather than in a request: a drop
 * outside any target, a drop back where it started, and a drop involving an id
 * the list does not hold. The last one is not paranoia -- a realtime event can
 * remove an item while a drag is in progress, and the reorder that followed
 * would otherwise send a list the server would reject or, worse, accept with the
 * dragged item silently missing.
 */
export function reorderIds(
  ids: readonly number[],
  activeId: number,
  overId: number | null,
): number[] | null {
  if (overId === null || overId === activeId) return null

  const from = ids.indexOf(activeId)
  const to = ids.indexOf(overId)
  if (from === -1 || to === -1) return null

  const next = [...ids]
  next.splice(to, 0, ...next.splice(from, 1))
  return next
}
